export const saStyles = `
/* -- Card Shell -- */
.sa-card {
  display: flex;
  flex-direction: column;
  gap: 2px;
  border-radius: 16px;
  border: 1px solid rgba(255,255,255,0.06);
  background: #09090b;
  padding: 0;
  overflow: hidden;
}

/* -- Header -- */
.sa-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  gap: 10px;
}

/* -- Badge -- */
.sa-badge {
  font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em;
  padding: 4px 12px; border-radius: 99px;
}
.sa-badge-contract { background: rgba(16,185,129,0.1); border: 1px solid rgba(16,185,129,0.25); color: #34d399; }
.sa-badge-guidance { background: rgba(245,158,11,0.1); border: 1px solid rgba(245,158,11,0.25); color: #fbbf24; }
.sa-badge-clarify { background: rgba(113,113,122,0.15); border: 1px solid rgba(113,113,122,0.25); color: #a1a1aa; }

.sa-source-label { font-size: 11px; font-weight: 600; color: #a1a1aa; max-width: 280px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* ── P72: Deadline Protection Banner — sits above six-section view. ──
   Severity-colored. Always the first thing the steward sees. */
.sa-deadline {
  margin: 12px 18px 4px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid rgba(255,255,255,0.12);
  display: flex; flex-direction: column; gap: 10px;
}
.sa-deadline-head {
  display: flex; align-items: center; gap: 8px;
}
.sa-deadline-label {
  font-size: 11px; font-weight: 800;
  letter-spacing: 0.06em; text-transform: uppercase;
}
.sa-deadline-days {
  margin-left: auto;
  padding: 3px 10px;
  border-radius: 99px;
  border: 1px solid;
  font-size: 11px; font-weight: 800;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.04em;
  white-space: nowrap;
}
.sa-deadline-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}
.sa-deadline-cell {
  padding: 6px 10px;
  border-radius: 8px;
  background: rgba(0,0,0,0.20);
}
.sa-deadline-cell-label {
  font-size: 9px; font-weight: 700;
  letter-spacing: 0.08em; text-transform: uppercase;
  color: #a1a1aa;
  margin-bottom: 2px;
}
.sa-deadline-cell-value {
  font-size: 13px; font-weight: 700; color: #fafafa;
  font-variant-numeric: tabular-nums;
}
.sa-deadline-action {
  font-size: 12px; line-height: 1.5;
  color: #fafafa;
  padding: 8px 10px;
  border-radius: 8px;
  background: rgba(0,0,0,0.20);
  border-left: 3px solid currentColor;
}
.sa-deadline-red    .sa-deadline-action { color: #fca5a5; }
.sa-deadline-orange .sa-deadline-action { color: #fed7aa; }
.sa-deadline-yellow .sa-deadline-action { color: #fde68a; }
.sa-deadline-green  .sa-deadline-action { color: #bbf7d0; }
.sa-deadline-unknown .sa-deadline-action { color: #d4d4d8; }

.sa-deadline-intake {
  display: flex; flex-wrap: wrap; gap: 6px;
  padding-top: 4px;
}
.sa-deadline-intake-pill {
  display: inline-flex; align-items: center;
  padding: 6px 12px;
  border-radius: 99px;
  background: rgba(255,255,255,0.04);
  border: 1px dashed rgba(167,139,250,0.45);
  color: #ddd6fe;
  font-size: 12px; font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.15s, border-color 0.15s;
}
.sa-deadline-intake-pill:hover {
  background: rgba(139,92,246,0.10);
  border-color: rgba(167,139,250,0.85);
}

@media (max-width: 700px) {
  .sa-deadline-grid { grid-template-columns: repeat(2, 1fr); }
}


/* ── P71: Six-Section Grievance Brief (Local 15 spec §16) ──
   The headline structure on every answer. Compact, scannable, color-coded
   by section tone (neutral / warn / info / success). Sits between the
   header and the detailed sections below. */
.sa-six {
  padding: 0 18px 4px;
  margin: 0 0 8px;
  display: flex; flex-direction: column; gap: 8px;
}
.sa-six-strip-head {
  display: flex; align-items: center; gap: 6px;
  font-size: 10px; font-weight: 800;
  letter-spacing: 0.08em; text-transform: uppercase;
  color: #a78bfa;
  padding: 12px 0 4px;
}
.sa-six-strip-head svg { color: #c4b5fd; }
.sa-six-row {
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 16px;
  padding: 10px 14px;
  border-radius: 10px;
  background: rgba(255,255,255,0.018);
  border-left: 3px solid rgba(167,139,250,0.35);
}
.sa-six-empty { opacity: 0.55; }
.sa-six-warn    { border-left-color: rgba(245,158,11,0.55); background: rgba(245,158,11,0.03); }
.sa-six-info    { border-left-color: rgba(96,165,250,0.55); background: rgba(96,165,250,0.025); }
.sa-six-success { border-left-color: rgba(34,197,94,0.55);  background: rgba(34,197,94,0.025); }

.sa-six-head {
  display: flex; align-items: flex-start; gap: 6px;
  font-size: 10px; font-weight: 800;
  letter-spacing: 0.06em;
  color: #d4d4d8;
}
.sa-six-head svg { flex-shrink: 0; margin-top: 1px; color: #a1a1aa; }
.sa-six-warn .sa-six-head    svg { color: #fbbf24; }
.sa-six-info .sa-six-head    svg { color: #93c5fd; }
.sa-six-success .sa-six-head svg { color: #86efac; }

.sa-six-body { min-width: 0; }
.sa-six-text {
  font-size: 13px; color: #fafafa; line-height: 1.5;
  font-weight: 500;
  white-space: pre-wrap;
}
.sa-six-list {
  margin: 0; padding: 0 0 0 16px;
  display: flex; flex-direction: column; gap: 4px;
  list-style: disc;
}
.sa-six-list li {
  font-size: 13px; color: #fafafa; line-height: 1.45;
  font-weight: 500;
}

@media (max-width: 700px) {
  .sa-six-row { grid-template-columns: 1fr; gap: 6px; }
  .sa-six-head { font-size: 9px; }
}

/* ── P73: Information Requests Panel ──
   Sits between the six-section view and the existing detail panels. */
.sa-info-requests {
  margin: 4px 18px 16px;
  padding: 0;
}
.sa-info-head {
  display: flex; align-items: center; gap: 6px;
  font-size: 10px; font-weight: 800;
  letter-spacing: 0.08em; text-transform: uppercase;
  color: #fbbf24;
  padding: 12px 0 8px;
}
.sa-info-head svg { color: #fbbf24; }
.sa-info-count {
  margin-left: 6px;
  padding: 2px 8px;
  border-radius: 99px;
  font-size: 10px; font-weight: 800;
  background: rgba(251,191,36,0.15);
  color: #fde68a;
  font-variant-numeric: tabular-nums;
}
.sa-info-list {
  display: flex; flex-direction: column; gap: 8px;
}
.sa-info-row {
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid;
}
.sa-info-row-head {
  display: flex; align-items: flex-start; gap: 10px;
  margin-bottom: 8px;
}
.sa-info-value {
  flex-shrink: 0;
  padding: 3px 9px;
  border-radius: 99px;
  border: 1px solid;
  font-size: 10px; font-weight: 800;
  letter-spacing: 0.06em;
  font-variant-numeric: tabular-nums;
}
.sa-info-request {
  font-size: 13px; font-weight: 700; color: #fafafa; line-height: 1.4;
}
.sa-info-meta {
  display: flex; flex-direction: column; gap: 6px;
  font-size: 12px; color: #d4d4d8; line-height: 1.45;
}
.sa-info-meta-row {
  display: flex; flex-direction: column; gap: 2px;
  padding: 6px 10px;
  border-radius: 6px;
  background: rgba(0,0,0,0.20);
}
.sa-info-meta-label {
  font-size: 9px; font-weight: 800;
  letter-spacing: 0.08em;
  color: #a1a1aa;
}


/* -- P74: Step 1 Meeting Prep -- */
.sa-s1 {
  margin: 4px 18px 16px;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.25);
  background: rgba(15, 23, 42, 0.45);
  overflow: hidden;
}
.sa-s1-toggle {
  display: flex; align-items: center; gap: 8px; width: 100%;
  padding: 12px 14px;
  background: linear-gradient(135deg, rgba(56, 189, 248, 0.10), rgba(148, 163, 184, 0.05));
  border: 0; cursor: pointer; text-align: left;
  font-size: 10px; font-weight: 800; letter-spacing: 0.10em;
  text-transform: uppercase; color: #bae6fd;
}
.sa-s1-toggle:hover { background: linear-gradient(135deg, rgba(56, 189, 248, 0.14), rgba(148, 163, 184, 0.08)); }
.sa-s1-toggle svg { color: #7dd3fc; flex-shrink: 0; }
.sa-s1-chip {
  margin-left: auto;
  padding: 2px 9px;
  border-radius: 99px;
  background: rgba(56, 189, 248, 0.15);
  color: #e0f2fe;
  font-size: 10px; font-weight: 700;
  letter-spacing: 0.04em; text-transform: none;
}
.sa-s1-body {
  padding: 0 14px 14px;
  display: flex; flex-direction: column; gap: 12px;
}
.sa-s1-block {
  border-radius: 10px;
  padding: 12px 14px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  background: rgba(0, 0, 0, 0.20);
}
.sa-s1-block-union     { border-color: rgba(74, 222, 128, 0.30); background: rgba(20, 83, 45, 0.18); }
.sa-s1-block-company   { border-color: rgba(248, 113, 113, 0.30); background: rgba(127, 29, 29, 0.18); }
.sa-s1-block-rebuttals { border-color: rgba(125, 211, 252, 0.30); background: rgba(12, 74, 110, 0.18); }
.sa-s1-block-head {
  display: flex; align-items: center; gap: 7px;
  font-size: 10px; font-weight: 800;
  letter-spacing: 0.10em; text-transform: uppercase;
  margin-bottom: 10px;
}
.sa-s1-block-union     .sa-s1-block-head { color: #86efac; }
.sa-s1-block-union     .sa-s1-block-head svg { color: #86efac; }
.sa-s1-block-company   .sa-s1-block-head { color: #fca5a5; }
.sa-s1-block-company   .sa-s1-block-head svg { color: #fca5a5; }
.sa-s1-block-rebuttals .sa-s1-block-head { color: #7dd3fc; }
.sa-s1-block-rebuttals .sa-s1-block-head svg { color: #7dd3fc; }
.sa-s1-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}
.sa-s1-grid-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
@media (max-width: 720px) {
  .sa-s1-grid, .sa-s1-grid-3 { grid-template-columns: 1fr; }
}
.sa-s1-cell {
  padding: 8px 10px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.04);
}
.sa-s1-cell-full { grid-column: 1 / -1; }
.sa-s1-label {
  font-size: 9px; font-weight: 800;
  letter-spacing: 0.08em;
  color: #94a3b8;
  margin-bottom: 5px;
}
.sa-s1-list {
  margin: 0; padding: 0 0 0 16px;
  font-size: 12.5px; color: #e5e7eb; line-height: 1.5;
  display: flex; flex-direction: column; gap: 4px;
}
.sa-s1-list li { padding-left: 2px; }


/* -- P75: Joint Position Summary panel -- */
.sa-jps {
  margin: 4px 18px 16px;
  border-radius: 12px;
  border: 1px solid rgba(217, 119, 6, 0.30);
  background: rgba(120, 53, 15, 0.18);
  overflow: hidden;
}
.sa-jps-toggle {
  display: flex; align-items: center; gap: 8px; width: 100%;
  padding: 12px 14px;
  background: linear-gradient(135deg, rgba(217, 119, 6, 0.10), rgba(202, 138, 4, 0.05));
  border: 0; cursor: pointer; text-align: left;
  font-size: 10px; font-weight: 800; letter-spacing: 0.10em;
  text-transform: uppercase; color: #fde68a;
}
.sa-jps-toggle:hover { background: linear-gradient(135deg, rgba(217, 119, 6, 0.16), rgba(202, 138, 4, 0.08)); }
.sa-jps-toggle svg { color: #fbbf24; flex-shrink: 0; }
.sa-jps-chip {
  margin-left: auto;
  padding: 2px 9px;
  border-radius: 99px;
  background: rgba(251, 191, 36, 0.18);
  color: #fef3c7;
  font-size: 10px; font-weight: 700;
  letter-spacing: 0.04em; text-transform: none;
}
.sa-jps-body {
  padding: 0 14px 14px;
  display: flex; flex-direction: column; gap: 12px;
}
.sa-jps-block {
  border-radius: 10px;
  padding: 10px 12px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(0, 0, 0, 0.20);
}
.sa-jps-block-company  { border-color: rgba(248, 113, 113, 0.30); background: rgba(127, 29, 29, 0.18); }
.sa-jps-block-union    { border-color: rgba(74, 222, 128, 0.30); background: rgba(20, 83, 45, 0.18); }
.sa-jps-block-resolved { border-color: rgba(125, 211, 252, 0.30); background: rgba(12, 74, 110, 0.18); }
.sa-jps-block-unresolved { border-color: rgba(248, 113, 113, 0.30); background: rgba(127, 29, 29, 0.18); }
.sa-jps-label {
  font-size: 10px; font-weight: 800;
  letter-spacing: 0.10em; text-transform: uppercase;
  color: #fde68a;
  margin-bottom: 6px;
}
.sa-jps-block-company  .sa-jps-label { color: #fca5a5; }
.sa-jps-block-union    .sa-jps-label { color: #86efac; }
.sa-jps-block-resolved .sa-jps-label { color: #7dd3fc; }
.sa-jps-block-unresolved .sa-jps-label { color: #fca5a5; }
.sa-jps-sublabel {
  font-size: 9px; font-weight: 800;
  letter-spacing: 0.08em;
  color: #94a3b8;
  margin-bottom: 4px;
}
.sa-jps-mini-label {
  font-size: 9px; font-weight: 700;
  color: #cbd5e1;
  margin-bottom: 3px;
}
.sa-jps-text {
  font-size: 13px; color: #fafafa; line-height: 1.5; margin: 0;
}
.sa-jps-hint {
  font-size: 11px; color: #94a3b8; margin: 0 0 6px; line-height: 1.4;
}
.sa-jps-list {
  margin: 0; padding: 0 0 0 16px;
  font-size: 12.5px; color: #e5e7eb; line-height: 1.5;
  display: flex; flex-direction: column; gap: 4px;
}
.sa-jps-list li { padding-left: 2px; }
.sa-jps-empty { font-size: 12px; color: #64748b; font-style: italic; }
.sa-jps-up-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
@media (max-width: 720px) { .sa-jps-up-grid { grid-template-columns: 1fr; } }
.sa-jps-up-full { grid-column: 1 / -1; }
.sa-jps-reb-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}
@media (max-width: 720px) { .sa-jps-reb-grid { grid-template-columns: 1fr; } }
.sa-jps-textarea {
  width: 100%;
  margin-top: 6px;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.30);
  color: #fafafa;
  font-size: 12.5px; font-family: inherit; line-height: 1.5;
  resize: vertical;
}
.sa-jps-textarea:focus {
  outline: 0; border-color: rgba(251, 191, 36, 0.40);
}
.sa-jps-actions {
  display: flex; justify-content: flex-end; padding-top: 4px;
}
.sa-jps-export-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid rgba(251, 191, 36, 0.45);
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.22), rgba(217, 119, 6, 0.16));
  color: #fef3c7;
  font-size: 11.5px; font-weight: 700; letter-spacing: 0.04em;
  cursor: pointer;
}
.sa-jps-export-btn:hover { background: linear-gradient(135deg, rgba(245, 158, 11, 0.32), rgba(217, 119, 6, 0.22)); }
.sa-jps-export-btn:disabled { opacity: 0.5; cursor: not-allowed; }


/* -- General Guidance Banner -- */
.sa-guidance-banner {
  display: flex; align-items: flex-start; gap: 10px;
  padding: 14px 20px;
  background: linear-gradient(135deg, rgba(245,158,11,0.1), rgba(249,115,22,0.05));
  border-bottom: 1px solid rgba(245,158,11,0.15);
  font-size: 13px; font-weight: 600; color: #fef3c7; line-height: 1.5;
}
.sa-guidance-banner svg { color: #fbbf24; flex-shrink: 0; margin-top: 1px; }

/* -- Section blocks -- */
.sa-section {
  margin: 0 12px 8px;
  border-radius: 12px;
  border: 1px solid rgba(255,255,255,0.05);
  background: rgba(24,24,27,0.6);
  overflow: hidden;
}
.sa-section-head {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 16px;
  border-bottom: 1px solid rgba(255,255,255,0.04);
}
.sa-section-title { font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.1em; }
.sa-section-icon { flex-shrink: 0; }
.sa-section-body {
  padding: 14px 16px;
  font-size: 14px; line-height: 1.65; color: #d4d4d8;
}
.sa-section-body p { margin: 0; }

/* Accent colors */
.sa-accent-violet .sa-section-head { background: rgba(139,92,246,0.06); }
.sa-accent-violet .sa-section-icon, .sa-accent-violet .sa-section-title { color: #a78bfa; }
.sa-accent-red .sa-section-head { background: rgba(239,68,68,0.06); }
.sa-accent-red .sa-section-icon, .sa-accent-red .sa-section-title { color: #f87171; }
.sa-accent-green .sa-section-head { background: rgba(16,185,129,0.06); }
.sa-accent-green .sa-section-icon, .sa-accent-green .sa-section-title { color: #34d399; }
.sa-accent-cyan .sa-section-head { background: rgba(6,182,212,0.06); }
.sa-accent-cyan .sa-section-icon, .sa-accent-cyan .sa-section-title { color: #67e8f9; }
.sa-accent-sky .sa-section-head { background: rgba(56,189,248,0.06); }
.sa-accent-sky .sa-section-icon, .sa-accent-sky .sa-section-title { color: #38bdf8; }
.sa-accent-orange .sa-section-head { background: rgba(249,115,22,0.06); }
.sa-accent-orange .sa-section-icon, .sa-accent-orange .sa-section-title { color: #fb923c; }
.sa-accent-pink .sa-section-head { background: rgba(236,72,153,0.06); }
.sa-accent-pink .sa-section-icon, .sa-accent-pink .sa-section-title { color: #f472b6; }
.sa-accent-amber .sa-section-head { background: rgba(245,158,11,0.06); }
.sa-accent-amber .sa-section-icon, .sa-accent-amber .sa-section-title { color: #fbbf24; }

/* Takeaway text */
.sa-takeaway-text { font-weight: 700; color: #ecfdf5; font-size: 15px; }

/* Blockquote (exact wording) */
.sa-blockquote {
  border-left: 4px solid rgba(139,92,246,0.4);
  padding-left: 16px; margin: 0;
  font-style: italic;
  color: #fafafa; font-weight: 500;
  line-height: 1.7;
}

/* ═══ Exact Contract Wording Block ═══ */
.sa-contract-source {
  margin: 0 12px 8px;
  border-radius: 12px;
  border: 2px solid rgba(16,185,129,0.3);
  background: rgba(16,185,129,0.04);
  overflow: hidden;
}
.sa-contract-source-head {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 16px;
  background: rgba(16,185,129,0.08);
  border-bottom: 1px solid rgba(16,185,129,0.15);
}
.sa-contract-source-head svg { color: #34d399; flex-shrink: 0; }
.sa-contract-source-title {
  font-size: 11px; font-weight: 800; text-transform: uppercase;
  letter-spacing: 0.1em; color: #34d399;
}
.sa-contract-source-badge {
  margin-left: auto;
  font-size: 9px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 3px 10px; border-radius: 4px;
  background: rgba(16,185,129,0.12); border: 1px solid rgba(16,185,129,0.25);
  color: #6ee7b7; white-space: nowrap;
}
.sa-contract-source-body { padding: 16px; }
.sa-contract-quote {
  border-left: 4px solid rgba(16,185,129,0.4);
  padding: 14px 16px; margin: 0 0 12px;
  font-size: 14px; font-weight: 500; line-height: 1.75;
  color: #f0fdf4; font-style: italic;
  background: rgba(16,185,129,0.03);
  border-radius: 0 8px 8px 0;
}
.sa-contract-cite {
  display: flex; align-items: center; gap: 8px;
  padding: 8px 12px; border-radius: 6px;
  background: rgba(16,185,129,0.06);
  border: 1px solid rgba(16,185,129,0.1);
  font-size: 12px; font-weight: 600; color: #6ee7b7;
}
.sa-contract-cite svg { flex-shrink: 0; color: #34d399; }

/* No quote fallback */
.sa-no-quote { color: #71717a; font-style: italic; }

/* Citation grid */
.sa-citation-grid { display: grid; gap: 6px; }
.sa-citation-grid strong { color: #a1a1aa; margin-right: 4px; }

/* Action steps */
.sa-steps { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 8px; }
.sa-step {
  display: flex; align-items: flex-start; gap: 10px;
  padding: 10px 12px; border-radius: 8px;
  background: rgba(16,185,129,0.04); border: 1px solid rgba(16,185,129,0.08);
  font-size: 14px; line-height: 1.5; color: #d4d4d8;
}
.sa-step-num {
  display: flex; align-items: center; justify-content: center;
  width: 22px; height: 22px; border-radius: 6px; flex-shrink: 0;
  background: rgba(16,185,129,0.15); color: #34d399;
  font-size: 12px; font-weight: 800;
}

/* Grievance */
.sa-grievance-text {
  border-radius: 10px; border: 1px solid rgba(245,158,11,0.15);
  background: rgba(245,158,11,0.04); padding: 14px;
  color: #fef3c7; white-space: pre-wrap;
}

/* Follow-up */
.sa-followup-text { font-weight: 600; color: #fef3c7; }

/* ═══ Follow-Up Pills (Intelligent Suggestions) ═══ */
.sa-followup-pills {
  margin: 4px 12px 10px;
  border-radius: 12px;
  border: 1px solid rgba(139,92,246,0.18);
  background: linear-gradient(135deg, rgba(139,92,246,0.07), rgba(236,72,153,0.03));
  overflow: hidden;
}
.sa-followup-pills-head {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 14px;
  background: rgba(139,92,246,0.08);
  border-bottom: 1px solid rgba(139,92,246,0.12);
  font-size: 11px; font-weight: 800; text-transform: uppercase;
  letter-spacing: 0.08em; color: #c4b5fd;
}
.sa-followup-pills-head svg { color: #a78bfa; flex-shrink: 0; }
.sa-followup-pills-body {
  padding: 12px 14px;
  display: flex; flex-direction: column; gap: 6px;
}
.sa-followup-pill {
  display: flex; align-items: center; justify-content: space-between;
  gap: 10px;
  width: 100%;
  padding: 10px 14px;
  border-radius: 10px;
  background: rgba(139,92,246,0.08);
  border: 1px solid rgba(139,92,246,0.22);
  color: #e9d5ff;
  font-size: 13px; font-weight: 600; line-height: 1.45;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s, transform 0.08s, color 0.15s;
  font-family: inherit;
}
.sa-followup-pill:hover {
  background: rgba(139,92,246,0.18);
  border-color: rgba(139,92,246,0.45);
  color: #faf5ff;
}
.sa-followup-pill:active { transform: translateY(1px); }
.sa-followup-pill:focus-visible {
  outline: 2px solid rgba(167,139,250,0.55);
  outline-offset: 2px;
}
.sa-followup-pill-text { flex: 1; }
.sa-followup-pill-arrow {
  flex-shrink: 0; color: #a78bfa;
  transition: transform 0.15s, color 0.15s;
}
.sa-followup-pill:hover .sa-followup-pill-arrow {
  color: #ddd6fe;
  transform: translateX(2px);
}

/* ═══ Hot Pills "Other stewards are also asking" — subtle social proof ═══ */
/* Visually lighter than the main follow-up pills: no card background, just
   small ghost chips on a transparent strip. Sits directly under the main
   follow-up section so it reads as a continuation, not a competing block. */
.sa-hot-pills {
  margin: -4px 12px 10px;       /* tucks under the .sa-followup-pills card */
  padding: 8px 14px 0;
  border-top: 0;
}
.sa-hot-pills-head {
  font-size: 10px; font-weight: 700;
  letter-spacing: 0.06em;
  color: #71717a;
  margin-bottom: 6px;
  text-transform: none;
}
.sa-hot-pills-body {
  display: flex; flex-wrap: wrap; gap: 6px;
}
.sa-hot-pill {
  display: inline-flex; align-items: center;
  padding: 5px 11px;
  border-radius: 99px;
  background: transparent;
  border: 1px dashed rgba(167,139,250,0.28);
  color: #a1a1aa;
  font-size: 12px; font-weight: 500; line-height: 1.3;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  transition: background-color 0.15s, border-color 0.15s, color 0.15s;
}
.sa-hot-pill:hover {
  background: rgba(139,92,246,0.06);
  border-color: rgba(167,139,250,0.55);
  color: #e9d5ff;
}
.sa-hot-pill:active { transform: translateY(1px); }
.sa-hot-pill:focus-visible {
  outline: 2px solid rgba(167,139,250,0.45);
  outline-offset: 2px;
}
.sa-hot-pill-text {
  /* Wrap long pill text gracefully on small screens */
  white-space: normal;
}

/* Footer */
.sa-footer {
  display: flex; align-items: baseline; gap: 8px;
  padding: 10px 20px 14px;
  border-top: 1px solid rgba(255,255,255,0.04);
  font-size: 12px;
}
.sa-q-label { font-weight: 700; color: #71717a; flex-shrink: 0; }
.sa-q-text { color: #71717a; }

/* Clarification card */
.sa-card-clarify { border-color: rgba(245,158,11,0.2); background: #09090b; }
.sa-clarify-inner {
  display: flex; align-items: flex-start; gap: 14px;
  padding: 22px 20px;
}
.sa-clarify-icon-el { color: #fbbf24; flex-shrink: 0; margin-top: 2px; }
.sa-clarify-label {
  font-size: 11px; font-weight: 800; text-transform: uppercase;
  letter-spacing: 0.08em; color: #fbbf24; margin-bottom: 6px;
}
.sa-clarify-text { margin: 0; font-size: 15px; font-weight: 500; color: #fef3c7; line-height: 1.6; }

/* Responsive */
@media (max-width: 640px) {
  .sa-section { margin: 0 8px 6px; }
  .sa-header { padding: 12px 14px; }
}

/* -- Decision Log Panel -- */
.dl-panel {
  margin: 4px 12px 8px;
  border-radius: 10px;
  border: 1px solid rgba(255,255,255,0.04);
  background: rgba(15,15,18,0.9);
  overflow: hidden;
}
.dl-toggle {
  display: flex; align-items: center; gap: 8px;
  width: 100%; padding: 8px 14px;
  background: none; border: none; cursor: pointer;
  font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em;
  color: #52525b;
  transition: color 0.15s;
}
.dl-toggle:hover { color: #a1a1aa; }
.dl-toggle svg:last-child { margin-left: auto; }

.dl-content {
  padding: 0 14px 14px;
  font-family: 'SF Mono', 'Fira Code', 'Consolas', monospace;
  font-size: 12px;
}

/* Human-readable reason banner */
.dl-reason {
  display: flex; align-items: flex-start; gap: 8px;
  padding: 10px 12px; margin-bottom: 10px;
  border-radius: 8px;
  background: rgba(139,92,246,0.06);
  border: 1px solid rgba(139,92,246,0.12);
  color: #c4b5fd;
  font-size: 12px; line-height: 1.5;
  font-family: inherit;
}
.dl-reason svg { flex-shrink: 0; margin-top: 2px; color: #a78bfa; }

/* Sections */
.dl-section { margin-bottom: 10px; }
.dl-section-label {
  font-size: 10px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.1em;
  color: #3f3f46; padding: 4px 0; margin-bottom: 2px;
  border-bottom: 1px solid rgba(255,255,255,0.03);
}

/* Rows */
.dl-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 3px 0;
  border-bottom: 1px solid rgba(255,255,255,0.02);
}
.dl-label { color: #52525b; font-size: 11px; }
.dl-value { color: #a1a1aa; font-size: 11px; font-weight: 600; }

/* Accent colors for values */
.dl-accent-green { color: #34d399; }
.dl-accent-amber { color: #fbbf24; }
.dl-accent-red { color: #f87171; }

/* Validator pass/fail */
.dl-validator-pass { color: #34d399; display: flex; align-items: center; gap: 4px; }
.dl-validator-fail { color: #f87171; display: flex; align-items: center; gap: 4px; }

/* Block reason */
.dl-block-reason {
  padding: 6px 10px; border-radius: 6px;
  background: rgba(239,68,68,0.05); border: 1px solid rgba(239,68,68,0.1);
  color: #fca5a5; font-size: 11px; line-height: 1.5;
}

/* Chunk cards */
.dl-chunk {
  margin-top: 6px; border-radius: 8px;
  border: 1px solid rgba(255,255,255,0.04);
  background: rgba(24,24,27,0.5);
  overflow: hidden;
}
.dl-chunk-head {
  display: flex; align-items: center; gap: 6px;
  padding: 6px 10px;
  background: rgba(255,255,255,0.02);
  font-size: 10px; font-weight: 700; color: #71717a;
  text-transform: uppercase; letter-spacing: 0.06em;
}
.dl-chunk-score { margin-left: auto; color: #52525b; font-weight: 600; }
.dl-chunk-body { padding: 8px 10px; }
.dl-chunk-meta {
  display: flex; flex-wrap: wrap; gap: 6px;
  font-size: 10px; color: #71717a; margin-bottom: 6px;
}
.dl-chunk-meta span {
  padding: 1px 6px; border-radius: 4px;
  background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.04);
}
.dl-chunk-issue {
  background: rgba(139,92,246,0.08) !important;
  border-color: rgba(139,92,246,0.15) !important;
  color: #a78bfa !important;
}
.dl-chunk-preview {
  font-size: 11px; color: #52525b; line-height: 1.5;
  max-height: 60px; overflow: hidden;
}

/* -- Steward Toolkit -- */
.stk-panel {
  margin: 4px 12px 8px;
  border-radius: 12px;
  border: 1px solid rgba(245,158,11,0.15);
  background: rgba(15,15,18,0.95);
  overflow: hidden;
}
.stk-panel-head {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 16px;
  background: rgba(245,158,11,0.06);
  border-bottom: 1px solid rgba(245,158,11,0.1);
  font-size: 11px; font-weight: 800; text-transform: uppercase;
  letter-spacing: 0.1em; color: #fbbf24;
}
.stk-panel-head svg { color: #fbbf24; flex-shrink: 0; }
.stk-panel-body { padding: 10px; display: flex; flex-direction: column; gap: 10px; }

/* Weingarten Card */
.stk-weingarten {
  border-radius: 10px;
  border: 1px solid rgba(239,68,68,0.15);
  background: rgba(239,68,68,0.03);
  overflow: hidden;
}
.stk-card-head {
  display: flex; align-items: center; gap: 8px;
  padding: 8px 14px;
  font-size: 10px; font-weight: 800; text-transform: uppercase;
  letter-spacing: 0.08em;
}
.stk-head-red {
  background: rgba(239,68,68,0.06);
  border-bottom: 1px solid rgba(239,68,68,0.1);
  color: #f87171;
}
.stk-head-red svg { color: #f87171; }
.stk-head-amber {
  background: rgba(245,158,11,0.06);
  border-bottom: 1px solid rgba(245,158,11,0.1);
  color: #fbbf24;
}
.stk-head-amber svg { color: #fbbf24; }
.stk-card-body { padding: 14px; display: flex; flex-direction: column; gap: 10px; }

/* Weingarten statement */
.stk-statement {
  border-left: 3px solid rgba(239,68,68,0.4);
  padding: 12px 14px; margin: 0;
  font-size: 14px; font-weight: 600; line-height: 1.7;
  color: #fecaca; font-style: italic;
  background: rgba(239,68,68,0.03); border-radius: 0 8px 8px 0;
}
.stk-instruction {
  font-size: 13px; color: #d4d4d8; line-height: 1.5;
}
.stk-trigger-reason {
  font-size: 11px; color: #71717a; line-height: 1.4;
  font-style: italic;
}

/* Grievance Draft */
.stk-grievance {
  border-radius: 10px;
  border: 1px solid rgba(245,158,11,0.15);
  background: rgba(245,158,11,0.02);
  overflow: hidden;
}
.stk-draft-badge {
  margin-left: auto;
  padding: 2px 8px; border-radius: 4px;
  font-size: 9px; font-weight: 800;
  background: rgba(245,158,11,0.15); color: #fbbf24;
  letter-spacing: 0.06em;
}
.stk-draft-notice {
  font-size: 12px; font-weight: 600; color: #fbbf24;
  padding: 8px 12px; border-radius: 6px;
  background: rgba(245,158,11,0.06);
  border: 1px solid rgba(245,158,11,0.1);
}

/* Fields */
.stk-field { display: flex; flex-direction: column; gap: 4px; }
.stk-field-label {
  font-size: 10px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.08em; color: #71717a;
}
.stk-field-value { font-size: 13px; color: #d4d4d8; line-height: 1.5; }

/* Contract ref status */
.stk-ref {
  display: flex; align-items: center; gap: 6px;
  font-size: 12px; font-weight: 600;
}
.stk-ref-confirmed { color: #34d399; }
.stk-ref-confirmed svg { color: #34d399; }
.stk-ref-unconfirmed { color: #fbbf24; }
.stk-ref-unconfirmed svg { color: #fbbf24; }
.stk-ref-text { font-size: 12px; color: #a1a1aa; line-height: 1.4; }

/* Remedies */
.stk-remedies {
  list-style: none; padding: 0; margin: 0;
  display: flex; flex-direction: column; gap: 4px;
}
.stk-remedy-item {
  display: flex; align-items: flex-start; gap: 8px;
  font-size: 13px; color: #d4d4d8; line-height: 1.5;
  padding: 6px 10px; border-radius: 6px;
  background: rgba(245,158,11,0.03);
  border: 1px solid rgba(245,158,11,0.06);
}
.stk-remedy-item::before {
  content: '\\2022'; color: #fbbf24; font-weight: 800; flex-shrink: 0;
}

/* Fields needing input */
.stk-fields-list { display: flex; flex-wrap: wrap; gap: 6px; }
.stk-field-tag {
  padding: 3px 10px; border-radius: 4px;
  font-size: 11px; font-weight: 600;
  background: rgba(113,113,122,0.1); border: 1px solid rgba(113,113,122,0.15);
  color: #a1a1aa;
}

/* Filing note */
.stk-filing-note {
  font-size: 12px; color: #71717a; line-height: 1.4;
  padding: 8px 10px; border-radius: 6px;
  background: rgba(255,255,255,0.02);
  border: 1px solid rgba(255,255,255,0.04);
}

/* Expand button */
.stk-expand-btn {
  display: flex; align-items: center; gap: 6px;
  background: none; border: 1px solid rgba(255,255,255,0.06);
  border-radius: 6px; padding: 6px 12px;
  font-size: 12px; font-weight: 600; color: #a1a1aa;
  cursor: pointer; transition: color 0.15s, border-color 0.15s;
}
.stk-expand-btn:hover { color: #d4d4d8; border-color: rgba(255,255,255,0.12); }

/* Template text */
.stk-template-text {
  font-family: 'SF Mono', 'Fira Code', 'Consolas', monospace;
  font-size: 12px; color: #a1a1aa; line-height: 1.6;
  padding: 14px; border-radius: 8px;
  background: rgba(24,24,27,0.8);
  border: 1px solid rgba(255,255,255,0.06);
  white-space: pre-wrap; word-wrap: break-word;
  max-height: 400px; overflow-y: auto;
  margin: 0;
}

/* Copy button */
.stk-copy-btn {
  display: flex; align-items: center; gap: 6px;
  padding: 7px 14px; border-radius: 6px;
  background: rgba(139,92,246,0.08); border: 1px solid rgba(139,92,246,0.2);
  color: #c4b5fd; font-size: 12px; font-weight: 600;
  cursor: pointer; transition: all 0.15s;
  align-self: flex-start;
}
.stk-copy-btn:hover { background: rgba(139,92,246,0.15); border-color: rgba(139,92,246,0.35); }
.stk-copy-btn svg { flex-shrink: 0; }

/* -- P81: Sources Panel ------------------------------------------------- */
.sa-sources-panel {
  border-top: 1px solid rgba(255,255,255,0.06);
  background: rgba(255,255,255,0.015);
}
.sa-sources-head {
  display: flex; align-items: center; gap: 8px;
  width: 100%; padding: 12px 16px;
  background: none; border: none; cursor: pointer;
  color: #e4e4e7; text-align: left;
  font-size: 11px; letter-spacing: 0.08em;
}
.sa-sources-head:hover { background: rgba(255,255,255,0.025); }
.sa-sources-title { flex-shrink: 0; font-weight: 600; }
.sa-sources-count {
  margin-left: auto; margin-right: 4px;
  color: #71717a; font-size: 11px; font-weight: 400; letter-spacing: 0;
}
.sa-sources-body {
  display: flex; flex-direction: column; gap: 8px;
  padding: 4px 16px 16px;
}
.sa-source-item {
  display: flex; flex-direction: column; gap: 6px;
  padding: 10px 12px;
  background: rgba(255,255,255,0.025);
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 10px;
}
.sa-source-row {
  display: flex; align-items: center; gap: 8px;
  flex-wrap: wrap;
}
.sa-source-chip {
  flex-shrink: 0;
  padding: 2px 8px;
  border: 1px solid;
  border-radius: 6px;
  font-size: 10px; font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.sa-source-title {
  flex: 1 1 auto;
  color: #f4f4f5; font-size: 13px; font-weight: 500;
  word-break: break-word;
}
.sa-source-score {
  flex-shrink: 0;
  padding: 2px 7px;
  background: rgba(34,197,94,0.1);
  color: #4ade80;
  border: 1px solid rgba(34,197,94,0.3);
  border-radius: 6px;
  font-size: 10px; font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.sa-source-sections {
  display: flex; gap: 5px; flex-wrap: wrap;
}
.sa-source-section-pill {
  padding: 1px 7px;
  background: rgba(96,165,250,0.08);
  color: #93c5fd;
  border: 1px solid rgba(96,165,250,0.25);
  border-radius: 5px;
  font-size: 10px;
  font-variant-numeric: tabular-nums;
}
.sa-source-actions {
  display: flex; align-items: center; gap: 12px;
  flex-wrap: wrap;
}
.sa-source-toggle, .sa-source-download {
  display: inline-flex; align-items: center; gap: 4px;
  background: none; border: none;
  color: #a1a1aa; font-size: 11px;
  cursor: pointer; padding: 2px 0;
  transition: color 0.15s;
}
.sa-source-toggle:hover { color: #e4e4e7; }
.sa-source-download {
  margin-left: auto;
  padding: 3px 10px;
  background: rgba(139,92,246,0.08);
  border: 1px solid rgba(139,92,246,0.3);
  border-radius: 6px;
  color: #c4b5fd;
}
.sa-source-download:hover:not(:disabled) {
  background: rgba(139,92,246,0.18);
  border-color: rgba(139,92,246,0.5);
  color: #ddd6fe;
}
.sa-source-download:disabled { opacity: 0.55; cursor: wait; }
.sa-source-chunks { color: #52525b; }
.sa-source-snippet {
  padding: 8px 10px;
  background: rgba(0,0,0,0.25);
  border-left: 2px solid rgba(167,139,250,0.5);
  border-radius: 4px;
  color: #d4d4d8;
  font-size: 12px; line-height: 1.55;
  font-style: italic;
  white-space: pre-wrap;
}
.sa-sources-footnote {
  margin-top: 4px;
  color: #52525b; font-size: 10px; font-style: italic;
  text-align: center;
}
`;
